module.exports = __webpack_public_path__ + "static/media/pw.383e482f.svg";